module.exports = __webpack_public_path__ + "new-agent/static/img/avatar-weon.4cd0d71.png";